import React, { useState, useEffect, useRef } from 'react';
import _axios from '../unit/axios';

function Space() {

    let isinit = false;
    useEffect(() => {
        if (!isinit) {
            isinit = true;
        }

    }, [])

    const [loading, setLoading] = useState(false);

    return (
        <>
            <iframe src={'http://www.childrenassessment.com.cn/space'} style={{ flex: '1', }} />
        </>

    )
}
export default Space;